<template>
  <div>
    <!-- 通告 -->
    <van-notice-bar
      v-if="noticeData.promptShowFlag"
      :wrapable="true"
      :scrollable="false"
      :text="noticeData.promptDetail"
      class="notice"
    />

    <x-card title="退款信息">
      <!-- 退款 -->
      <x-picker
        v-if="type === AfterSalesType.退款 && $state.delivered"
        v-model="status"
        title="选择收货状态"
        :data="statusList"
      >
        <template #default="{ label, picked }">
          <div class="item">
            <div class="label">收货状态<span class="star">*</span></div>
            <div :class="['value', !picked && 'unpicked']">
              {{ picked ? label : '请选择' }}
            </div>
            <van-icon name="arrow" class="arrow" />
          </div>
        </template>
      </x-picker>
      <x-picker
        v-if="type === AfterSalesType.退款 || type === AfterSalesType.退货退款"
        v-model="reason"
        title="选择退款原因"
        :data="reasonList"
      >
        <template #default="{ label, picked }">
          <div class="item">
            <div class="label">退款原因<span class="star">*</span></div>
            <div :class="['value', !picked && 'unpicked']">
              {{ picked ? label : '请选择' }}
            </div>
            <van-icon name="arrow" class="arrow" />
          </div>
        </template>
      </x-picker>
      <div
        v-if="type === AfterSalesType.退款 || type === AfterSalesType.退货退款"
        class="item"
      >
        <div class="label">退款金额(元)<span class="star">*</span></div>
        <div class="value important">
          <input
            v-model="money"
            v-fix-keyboard
            type="number"
            class="input"
            placeholder="请输入"
            :readonly="!$state.delivered"
          />
        </div>
      </div>
      <div
        v-if="type === AfterSalesType.退款 || type === AfterSalesType.退货退款"
        class="item tips"
      >
        <template v-if="$state.delivered">
          可修改，最多￥{{ maxMoney }}
        </template>
        <template v-else>退款金额不可修改</template>
      </div>

      <!-- 退货退款 -->
      <!-- <div v-if="type === AfterSalesType.退货退款" class="item">
        <div class="label">退货方式</div>
        <div class="value">买家自行寄回</div>
      </div> -->

      <!-- 换货 -->
      <x-picker
        v-if="type === AfterSalesType.换货"
        v-model="reason"
        title="选择换货原因"
        :data="reasonList"
      >
        <template #default="{ label, picked }">
          <div class="item">
            <div class="label">换货原因<span class="star">*</span></div>
            <div :class="['value', !picked && 'unpicked']">
              {{ picked ? label : '请选择' }}
            </div>
            <van-icon name="arrow" class="arrow" />
          </div>
        </template>
      </x-picker>
    </x-card>
    <x-card title="补充描述和凭证">
      <van-field
        v-model="desc"
        v-fix-keyboard
        class="desc"
        type="textarea"
        rows="3"
        placeholder="请描述申请售后服务的原因"
        maxlength="100"
        show-word-limit
      />
      <x-image-picker
        v-model="files"
        class="upload"
        :limit="6"
        placeholder="上传凭证"
      />
    </x-card>

    <x-card
      v-if="type === AfterSalesType.退货退款 || type === AfterSalesType.换货"
      title="退换货方式"
      :class="_.method"
    >
      <div :class="_.type">
        <div
          v-if="$state.canSelfDelivery"
          :class="[_.item, returnType === 1 && _.selected]"
          @click="returnType = 1"
        >
          自行邮寄
        </div>
        <div
          v-if="$state.canPickup"
          :class="[_.item, returnType === 2 && _.selected]"
          @click="returnType = 2"
        >
          上门取货
        </div>
      </div>
      <div v-if="returnType === 2" :class="_.address">
        <div :class="_.top">
          <div :class="_.label">快递员上门取货</div>
        </div>
        <div :class="_.bottom" @click="handleAddressClick">
          <img src="./images/submit/定位.png" :class="_.icon" />
          <div :class="[_.message, !address.id && _.placeholder]">
            {{
              `${address.province || ''}${address.city || ''}${
                address.county || ''
              }${address.detail || ''}` || '请添加退换货地址'
            }}
          </div>
          <img src="./images/submit/箭头.png" :class="_.arrow" />
        </div>
      </div>
    </x-card>

    <x-bottom-bar>
      <div :class="_.actions">
        <x-button
          v-track="{
            name: '申请售后-提交',
            id: '3c05d550-db84-4420-bc08-280ee9c77ff7',
          }"
          :class="_.button"
          @click="handleSubmitClick"
        >
          提交
        </x-button>
      </div>
    </x-bottom-bar>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { yup as _ } from 'vtils/validator'
  import { AddressBridge } from '@/views/address/bridge'
  import { afterSalesModel } from './_model'
  import { AfterSalesType } from '../_model'
  import {
    apiSaleAfterStandardEcommerceSaleAfterApply,
    apiSaleAfterStandardEcommerceSaleAfterFindById,
    apiSaleAfterStandardEcommerceSaleAfterGetOptions,
    apiSaleAfterStandardEcommerceSaleAfterGetPrompt,
    apiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimit,
  } from '@/api'
  import { mapQuery, prepareData, submit, Track } from '@/utils'
  import { navigateBack } from '@/router'
  import { pick } from '@dcb/utils'
  import { wait } from 'vtils'

  export default Vue.extend({
    mixins: [
      afterSalesModel.mixin,
      mapQuery({
        // 售后类型
        type: {
          key: 'type',
          transformer: Number,
          default: AfterSalesType.退款,
        },
        // 重新申请时传入的售后 ID
        id: 'id',
      }),
      Track.provideMark(() => ({
        page: '提交售后申请',
      })),
    ],

    data: () => ({
      AfterSalesType,
      // 最多退款金额
      maxMoney: 0,
      // 收货状态列表
      statusList: [
        {
          label: '暂无物流信息',
          value: 1,
        },
        {
          label: '未签收',
          value: 2,
        },
        {
          label: '已签收',
          value: 3,
        },
      ],
      // 退款原因列表
      reasonList: [],
      // 通告数据
      noticeData: {},
      // 当前状态：1、2、3
      status: undefined,
      // 当前原因
      reason: '',
      // 退款金额
      money: 0,
      // 备注
      desc: '',
      // 附件
      files: [],
      // 1 自寄 2 上门
      returnType: 1,
      // 退换货地址
      address: {},
    }),

    async mounted() {
      await new Promise(resolve => {
        const { unwatchBeforeDestroy } = afterSalesModel.watch(
          state => state.requestAmount,
          async () => {
            if (afterSalesModel.state.requestAmount) {
              const { refundAmount } =
                await apiSaleAfterStandardEcommerceSaleAfterGetRefundAmountAndQuantityLimit(
                  {
                    refOrderNo: afterSalesModel.state.orderNo,
                    skuId: afterSalesModel.state.skuId,
                    quantity: afterSalesModel.state.requestAmount,
                  },
                )
              this.maxMoney = refundAmount
              this.money = this.maxMoney
            }
            resolve()
          },
          { immediate: true },
        )
        unwatchBeforeDestroy(this)
      })

      const { reasonList, noticeData, afterSalesData } = await prepareData({
        reasonList: apiSaleAfterStandardEcommerceSaleAfterGetOptions({
          type: this.type,
        }),
        noticeData: afterSalesModel.state.fromInstantDelivery
          ? {}
          : apiSaleAfterStandardEcommerceSaleAfterGetPrompt({
              refOrderNo: afterSalesModel.state.orderNo,
              skuId: afterSalesModel.state.skuId,
            }),
        afterSalesData: this.id
          ? apiSaleAfterStandardEcommerceSaleAfterFindById({
              id: this.id,
            })
          : {},
      })
      this.reasonList = reasonList.map(item => ({
        label: item,
        value: item,
      }))
      this.noticeData = noticeData
      if (this.id) {
        this.status = afterSalesData.returnLogisticsWaybillStatus
        this.reason = afterSalesData.applyReason
        this.desc = afterSalesData.applyReasonAddDescription
        this.files = afterSalesData.applyPic
        afterSalesModel.update({
          requestAmount: afterSalesData.quantity,
        })
        this.money =
          afterSalesData.refundAmount < this.money
            ? afterSalesData.refundAmount
            : this.money
      }
    },

    methods: {
      async handleAddressClick() {
        const address = await AddressBridge.chooseAddress()
        console.log(address)
        this.address = address || {}
        try {
          await wait(60)
          document.querySelector('.__page_container__').scrollTo({ top: 2000 })
        } catch {}
      },
      handleSubmitClick() {
        submit(async $ => {
          const formData = {
            ...pick(this, [
              'status',
              'reason',
              'money',
              'desc',
              'files',
              'returnType',
              'address',
            ]),
            amount: afterSalesModel.state.requestAmount,
          }
          const schema =
            this.type === AfterSalesType.退款
              ? _.object({
                  status: afterSalesModel.state.delivered
                    ? _.number().required('请选择收货状态')
                    : _.number(),
                  reason: _.string().required('请选择退款原因'),
                  money: _.number()
                    .label('退款金额')
                    // .moreThan(0, '退款金额应大于0')
                    .max(this.maxMoney, '退款金额不能大于可退金额'),
                  amount: afterSalesModel.state.delivered
                    ? _.mixed()
                    : _.number()
                        .required('请输入申请数量')
                        .min(1, '申请数量应大于1')
                        .max(
                          afterSalesModel.state.fromInstantDelivery
                            ? 100000
                            : afterSalesModel.state.goodsData.quantity,
                          '申请数量不能大于购买量',
                        ),
                })
              : this.type === AfterSalesType.退货退款
              ? _.object({
                  reason: _.string().required('请选择退款原因'),
                  money: _.number()
                    .label('退款金额')
                    // .moreThan(0, '退款金额应大于0')
                    .max(this.maxMoney, '退款金额不能大于可退金额'),
                  amount: afterSalesModel.state.delivered
                    ? _.mixed()
                    : _.number()
                        .required('请输入申请数量')
                        .min(1, '申请数量应大于1')
                        .max(
                          afterSalesModel.state.goodsData.quantity,
                          '申请数量不能大于购买量',
                        ),
                })
              : _.object({
                  reason: _.string().required('请选择换货原因'),
                })
          const { error, data } = await schema.validatePlus(formData)
          if (error) {
            await $.fail(error.message)
          } else {
            if (
              this.type === AfterSalesType.换货 ||
              this.type === AfterSalesType.退货退款
            ) {
              if (data.returnType === 2 && !data.address.id) {
                await $.fail('请添加退换货地址')
                return
              }
            }
            await $.start('提交中...')
            const id = await apiSaleAfterStandardEcommerceSaleAfterApply({
              id: this.id || undefined,
              refOrderNo: afterSalesModel.state.orderNo,
              saleAfterType: this.type,
              quantity: data.amount,
              returnLogisticsWaybillStatus: data.status,
              applyReason: data.reason,
              applyReasonAddDescription: data.desc,
              applyReasonAddPic: this.files,
              refundAmount: data.money,
              skuId: afterSalesModel.state.skuId,
              returnCommodityType: data.returnType,
              pickupAddress: {
                province: data.address.province,
                city: data.address.city,
                area: data.address.county,
                areaCode: data.address.districtCode,
                detail: data.address.detail,
                name: data.address.receiver,
                phoneNo: data.address.phoneNo,
                contact: data.address.receiver,
                contactTel: data.address.phoneNo,
              },
            })
            await $.success('提交成功')
            afterSalesModel.update({
              afterSalesId: id,
            })
            navigateBack()
          }
        })
      },
    },
  })
</script>

<style lang="scss" scoped>
  .notice {
    background-color: #fff2f1;
    color: #ff111c;
    font-size: 12px;
    line-height: 18px;
    padding: 8px 12px;
    margin-bottom: -10px;
  }

  .item {
    display: flex;
    align-items: center;
    margin-top: 12px;

    .label {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #222222;

      .star {
        color: #f10b13;
      }
    }

    .value {
      flex-grow: 1;
      text-align: right;
      font-size: 12px;
      color: #222222;

      &.unpicked {
        color: #888888;
      }

      .input {
        width: 100%;
        text-align: right;
        appearance: none;
        box-shadow: none;
        border: none;
        border-radius: 0;
        outline: none;
      }

      &.important {
        font-size: 14px;
        font-weight: bold;
        color: #f10b13;
      }
    }

    .arrow {
      margin-left: 6px;
      font-size: 14px;
      color: #bebebe;
    }

    &.tips {
      margin-top: 8px;
      font-size: 12px;
      color: #888888;
    }
  }

  .desc {
    background: #f5f6f8;
    border-radius: 8px;

    ::v-deep {
      .van-field__control {
        &::placeholder {
          color: #999;
        }
      }

      .van-field__word-limit {
        color: #999;
      }
    }
  }

  .upload {
    margin-top: 12px;
  }
</style>

<style lang="scss" module>
  .method {
    .type {
      display: flex;
      align-items: center;
      gap: 13px;

      .item {
        width: 50%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        font-style: normal;
        border: 1px solid #e9e9e9;
        box-sizing: border-box;
        border-radius: 8px;

        &.selected {
          background: #fff2f1;
          border-color: #ff111c;
          color: #ff111c;
        }
      }
    }

    .address {
      margin-top: 12px;

      .top {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .label {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          line-height: 17px;
          font-style: normal;
        }

        .extra {
          display: flex;
          align-items: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #ff111c;
          line-height: 17px;
          font-style: normal;

          .arrow {
            margin-left: 2px;
            width: 12px;
            height: 12px;
          }
        }
      }

      .bottom {
        margin-top: 6px;
        min-height: 48px;
        background: #f5f5f5;
        border-radius: 6px;
        display: flex;
        align-items: center;
        padding: 12px;
        box-sizing: border-box;

        .icon {
          flex-shrink: 0;
          width: 19px;
          height: 19px;
        }

        .message {
          flex-grow: 1;
          margin-left: 2px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          font-style: normal;

          &.placeholder {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #666666;
            line-height: 17px;
            font-style: normal;
          }
        }

        .arrow {
          flex-shrink: 0;
          width: 12px;
          height: 12px;
        }

        &:active {
          filter: contrast(0.9) opacity(0.9);
        }
      }
    }
  }

  .actions {
    height: 66px;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;

    .button {
      flex-grow: 1;
      margin: 0 12px 0 12px;
    }
  }
</style>
